import './ChooseTeamFantasyDialog.scss';


import moment = require("moment");
import Delegate from '../1. Core/Delegate';
import Dialog from '../1. Core/Controls/Dialog/Dialog';
import Label from '../1. Core/Controls/Label/Label';
import {DistributionPoint, FantasyInfo, FantasyRateRow, UserCard} from './types';
import Button from '../1. Core/Controls/Button/Button';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListBox, {ListBoxItemArgs} from "../1. Core/Controls/ListBox/ListBox";
import {IState} from "../2. Athletes/StatesList";
import {RecordData} from "../10. Battle/types";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import {getCountries} from "../10. Battle/Util";
import ListItemCheckBox from "../1. Core/Controls/ListBox/ListItemCheckBox";


export default class ChooseTeamFantasyDialog extends Dialog {

	private _FantasyId: number;
	private EvCreated: Delegate;
	private _pointsLabel: Label;
	private _tblNode: HTMLTableElement;
	private countryies: IState[];
	private _MyPoints: number;
	private _myAthletes: FantasyRateRow[];
	private _allBtns: Button[];
	private _FInfo: FantasyInfo;


	_initFields(settings: object)
	{
		this.EvCreated = new Delegate();
		this._FantasyId = null;
		super._initFields(settings);
		this._Caption = '';
		this._ShowHeader = true;
		this._Mode = 'FullScreen';
		this._ShowCloseButton = true;
		this._CloseOnFrameMouseDown = false;
		this._UseSinglePaddingContent = false;

		this._ShowButtons = false;
		this._OkRK = 'Save'

		this._allBtns = [];
		this._myAthletes = [];
		this._MyPoints = 100;
	}

	_render()
	{
		super._render();
		this.addClass('choose-team-fantasy-dialog')

		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		this._pointsLabel = new Label({
			ParentNode: this._contentNode,
			Class: 'points-lbl'
		});

		this._topAppBar.addItem(new Button({
			Content: 'Fantasy ' + NP.RM.getString('Rules'),
			Class: 'rules-btn',
			EvClick: () =>
			{
				window.open('fantasy-rules-en?c=' + new Date().getTime());
			}
		}), this._topAppBar.getRightItems()[0])

		this.refresh();
	}

	buyButtonClick(info: FantasyRateRow, btn: Button)
	{
		let ritem = this._myAthletes.find(item => item.AthleteId == info.AthleteId);
		if (ritem)
		{
			ritem.AdPoints = info.AdPoints = null;
			NP.removeFromArray(this._myAthletes, ritem);
			this._MyPoints += info.Points;
			btn.setRK('Buy');
			btn.removeClass('green-btn');
			this.updateBuyButtons();
		}
		else if (this._MyPoints < info.Points)
			NP.showMessage({RK: 'InsufficientFunds'})
		else
			new ChooseAdditionalParams({
				EvOkButtonClick: (dlg: ChooseAdditionalParams) =>
				{
					info.AdPoints = dlg.getParams();
					info.SelectedUserCards = dlg.getSelectedCards().map(it => it.id)

					btn.addClass('green-btn')
					this._myAthletes.push(info)
					this._MyPoints -= info.Points;
					btn.setRK('Cancel');
					this.updateBuyButtons();
				}
			}).show()
	}

	updatePointsLabel()
	{
		this._pointsLabel.setContent(`${NP.RM.getString("Player")} : ${NP.getCurrentUser().getViewName()} <br/> ${NP.RM.getString("Balance")}: ${this._MyPoints}`);
	}

	updateBuyButtons()
	{

		this.updatePointsLabel();

		this._allBtns.forEach(b =>
		{
			//дизаблим кнопки на которые не хватает очков
			let bi = b.getTag() as FantasyRateRow;
			if (!this._myAthletes.find(a => a.AthleteId == bi.AthleteId))
				b.setEnabled(this._MyPoints >= bi.Points);

			let cell = b.getValue() as HTMLElement;

			cell.querySelector('.team-fantasy-bought-params').innerHTML = '';
		})

		this._myAthletes.forEach(a =>
		{
			//дизаблим противников у купленных бойцов
			let vsBtn = this._allBtns.find(b => (b.getTag() as FantasyRateRow).AthleteId != a.AthleteId && (b.getTag() as FantasyRateRow).BattleId == a.BattleId);
			vsBtn.setEnabled(false);

			let myBtn = this._allBtns.find(b => (b.getTag() as FantasyRateRow).AthleteId == a.AthleteId && (b.getTag() as FantasyRateRow).BattleId == a.BattleId);
			let cell = myBtn.getValue() as HTMLElement;
			(cell.querySelector('.team-fantasy-bought-params') as HTMLElement).innerText = a.AdPoints.map(item => item.Name).join('\n');
		});
	}

	renderLeftAthlete(info: FantasyRateRow, parentNode: HTMLElement)
	{
		let country = this.countryies.find(c => c.Id == info.CountryId)

		let flagUrl = country ? NP.getCurrentUser().getAppSettings().CountryFlagFolder + country.ISO + `.png` : ''

		let tbl = NP.parseHTML(`<table><tbody>

<tr> 
<td rowspan="3" style="position: relative; width: 100px; height: 150px;"> 
	<img class="fantasy-flag-athlete" src="${flagUrl}"/>
	<img class="fantasy-photo-athlete" src="${info.PhotoUrl}"/>
	
</td>
<td>
<span style="margin-left: 16px; font-size: 20px; font-weight: 900;"> ${info.FirstName} ${info.LastName} </span>
</td>
</tr>

<tr>
	<td>
	<span style="margin-left: 16px"> <a href="/mmaathletes/${info.AthleteId}" target="_blank">${NP.RM.getString('Statistics')}</a>  </span>
	</td>
</tr>

<tr>

<td><span style="margin-left: 16px" class="history-link">${NP.RM.getString('History')}</span></td>
</tr>


</tbody></table>`);

		tbl.style.width = '400px';
		tbl.style.textAlign = 'left';

		parentNode.appendChild(tbl);

		this.addEvent(tbl.querySelector('.history-link'), 'click', () => this.showRecordDataDialog(info.AthleteId));

		return tbl;
	}

	renderRightAthlete(info: FantasyRateRow, parentNode: HTMLElement)
	{
		let country = this.countryies.find(c => c.Id == info.CountryId)
		let flagUrl = country ? NP.getCurrentUser().getAppSettings().CountryFlagFolder + country.ISO + `.png` : ''
		let tbl = NP.parseHTML(`<table><tbody>

<tr> 

<td>
<span style="margin-left: 16px;  font-size: 20px; font-weight: 900;"> ${info.FirstName} ${info.LastName} </span>
</td>
<td rowspan="3" style="position: relative; width: 100px; height: 150px;"> 
	<img class="fantasy-flag-athlete" src="${flagUrl}"/>
	<img class="fantasy-photo-athlete" src="${info.PhotoUrl}"/>
	
</td>
</tr>

<tr>
	<td>
	<span style="margin-right: 16px"> <a href="/mmaathletes/${info.AthleteId}" target="_blank">${NP.RM.getString('Statistics')}</a>  </span>
	</td>
</tr>

<tr>
<td><span style="margin-right: 16px" class="history-link">${NP.RM.getString('History')}</span></td>
</tr>


</tbody></table>`);

		tbl.style.width = '400px';
		tbl.style.textAlign = 'right';


		parentNode.appendChild(tbl);

		this.addEvent(tbl.querySelector('.history-link'), 'click', () => this.showRecordDataDialog(info.AthleteId));

		return tbl;
	}

	async showRecordDataDialog(athleteId: number)
	{
		let data = await ServerAPI.callUiApi(`/athlete/getRecordData/${athleteId}`) as RecordData[];


		let dlg = (new Dialog({
			ShowHeader: true,
			Width: 900,
			Height: 500,
			Class: 'nopad',
			Caption: NP.RM.getString('FightHistory'),
			ContentAutoFit: true,
			ShowCloseButton: true,
			ShowButtons: false,
			Content: new DataTable({
				Class: 'app-list--avatars mdc-data-table--margin',
				Rows: data.map(row => ({
					...row,
					Date: row.Date ? moment(row.Date).format(NP.getDayFormat()) : ''
				})),
				ImageWidth: 32,
				Columns: [{
					Content: NP.RM.getString('Date'),
					Width: '20%',
					PropertyContent: 'Date'
				}, {
					Content: 'Result',
					Width: '10%',
					PropertyContent: 'Result'
				}, {
					Content: 'Opponent',
					PropertyContent: 'Opponent',
					Width: '30%'
				}, {
					Content: 'Method',
					PropertyContent: 'WinType',
					Width: '20%'
				}, {
					Content: 'Time',
					PropertyContent: 'EndTime',
					Width: '20%'
				}]
			})
		}));

		dlg.show();
	}


	async refresh()
	{
		this._FInfo = await ServerAPI.callUiApi(`/fantasy/${this._FantasyId}`) as FantasyInfo;
		this.countryies = await getCountries(true) as IState[];
		let items = this._FInfo.Points.sort((a: FantasyRateRow, b: FantasyRateRow) => a.BattleId - b.BattleId)

		this._tblNode = NP.createNode(this._contentNode, 'fantasy-magazine-tbl', 'table');

		for (let i = 0; i < items.length - 1; i += 2)
		{
			let row = this._tblNode.insertRow();

			//left athlete

			let leftCell = row.insertCell();

			this.renderLeftAthlete(items[i], leftCell)

			let cell = row.insertCell();
			cell.style.width = '100px'

			NP.createNode(cell, 'fantasy-price').innerText = `${items[i].Points}`;

			let btn = new Button({
				RK: "Buy",
				ParentNode: cell,
				Class: 'app-button--raised',
				Width: 40,
				Height: 30,
				Tag: items[i],
				Value: leftCell,
				EvClick: () => this.buyButtonClick(items[i], btn)
			})

			this._allBtns.push(btn);

			NP.createNode(leftCell, 'team-fantasy-bought-params team-fantasy-bought-params--left');

			//VS
			cell = row.insertCell();
			cell.style.width = '100px'

			let vsSpan = NP.createNode(cell, 'vs-text', 'span');

			if (items[i].BattleCount > 1 && items[i + 1].BattleCount > 1)
				vsSpan.innerHTML = `VS <br/> <a target="_blank" href="/mma-compare.html?red=${items[i].GAthleteId}&blue=${items[i + 1].GAthleteId}&lang=en">${NP.RM.getString('Compare')}</a>`;
			else
				vsSpan.innerText = 'VS';


			//right athlete
			cell = row.insertCell();
			cell.style.width = '100px';

			NP.createNode(cell, 'fantasy-price').innerText = `${items[i + 1].Points}`;

			let rightCell = row.insertCell();
			let btn2 = new Button({
				RK: "Buy",
				ParentNode: cell,
				Class: 'app-button--raised',
				Width: 40,
				Height: 30,
				Value: rightCell,
				Tag: items[i + 1],
				EvClick: () => this.buyButtonClick(items[i + 1], btn2)
			})

			this._allBtns.push(btn2);


			this.renderRightAthlete(items[i + 1], rightCell);

			NP.createNode(rightCell, 'team-fantasy-bought-params team-fantasy-bought-params--right');

			row.style.borderBottom = '1px solid #eee'
		}


		this._myAthletes = await ServerAPI.callUiApi(`/fantasy/getBoughtFantasy/${this._FantasyId}`) as FantasyRateRow[];

		if (this._myAthletes.length)
		{
			this._MyPoints -= this._myAthletes.map(a => a.Points).reduce((s, v) => s + v);


			this._allBtns.forEach(btn =>
			{
				let info = btn.getTag() as FantasyRateRow;
				if (this._myAthletes.find(a => a.AthleteId == info.AthleteId))
				{
					btn.addClass('green-btn');
					btn.setRK('Cancel');
				}
			});

			this.updateBuyButtons();
		}
		else
			this.updatePointsLabel();
	}


	async _onOkButtonClick()
	{
		if (this._myAthletes.length == 0)
		{
			NP.showMessage({Content: 'Athlete list is empty'})
			return;
		}
		await ServerAPI.post(`/fantasy/buyFantasy/${this._FantasyId}`, this._myAthletes)
		this.hide();
	}
}


class ChooseAdditionalParams extends Dialog {

	private _ad2: boolean;
	private _ad1: boolean;
	private _listAd1: ListBox;
	private _listAd2: ListBox;
	private _cardList: ListBox;
	private _userCards: UserCard[];


	_initFields(settings: object)
	{

		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('AdditionalParameters');
		this._ShowHeader = true;
		this._Width = 666;
		this._ShowCloseButton = true;
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();
		this.addClass('nopad choose-additional-params-dlg');
		this.refresh()
	}

	async refresh()
	{
		let dpoints = await ServerAPI.callUiApi("/fantasy/getDistributionPoints") as DistributionPoint[];
		this._userCards = await ServerAPI.get<UserCard[]>(`/cards/getUserCards/${NP.getCurrentUser().getKey()}`)

		this._listAd1 = new ListBox({
			ParentNode: this._contentNode,
			Items: [{IsHeader: true, RK: 'Additional1'}],
			EvItemSelected: (list: ListBox, e: ListBoxItemArgs) =>
			{
				if (!e.Item.getSelected())
				{
					this._ad1 = false;
					this._listAd1.getItems().forEach(c => c.setEnabled(true))
				}
				else
				{
					let cntChecked = this._listAd1.getItems().filter(c => c instanceof ListItemCheckBox && c.getSelected()).length;
					if (cntChecked == 1)
					{
						this._listAd1.getItems().forEach(c =>
						{
							if (c instanceof ListItemCheckBox && !c.getSelected())
								c.setEnabled(false)
						});
						this._ad1 = true;
					}
					else
						this._ad1 = false;
				}

				this.checkEnabledOk();
				this.refreshUserCards()
			}
		});

		this._listAd2 = new ListBox({
			ParentNode: this._contentNode,
			Items: [{IsHeader: true, RK: 'Additional2'}],
			EvItemSelected: (list: ListBox, e: ListBoxItemArgs) =>
			{
				if (!e.Item.getSelected())
				{
					this._ad2 = false;
					this._listAd2.getItems().forEach(c => c.setEnabled(true))
				}
				else
				{
					let cntChecked = this._listAd2.getItems().filter(c => c instanceof ListItemCheckBox && c.getSelected()).length;
					if (cntChecked == 2)
					{
						this._listAd2.getItems().forEach(c =>
						{
							if (c instanceof ListItemCheckBox && !c.getSelected())
								c.setEnabled(false)
						});
						this._ad2 = true;
					}
					else
						this._ad2 = false;
				}

				this.checkEnabledOk();
				this.refreshUserCards()
			}
		});


		for (let p of dpoints)
		{
			let item = {
				Content: p.Name,
				Tag: p,
				IsCheckBox: true,
				FontImage: ' '
			};
			if (p.Type == 'Additional1')
			{
				this._listAd1.addItem(item);
			}
			else if (p.Type == 'Additional2')
			{
				if (p.Points > 0)
					this._listAd2.addItem(item);
			}
		}


		this._cardList = new ListBox({
			ParentNode: this._contentNode
		})

		this._okButton.setEnabled(false);
	}

	refreshUserCards()
	{
		let selectedParams = this.getParams()
		let cardsForShow  = this._userCards
			 .filter(it => selectedParams.find(s => s.Key == it.fantasyPointId))

		let s = new Set();
		let uniqCardList = [];
		cardsForShow.forEach(it => {
			if (!s.has(it.cardId))
			{
				s.add(it.cardId)
				uniqCardList.push(it)
			}
		})


		this._cardList.setItems(
			 [{IsHeader: true, Content: 'Select cards...'},
				  ...uniqCardList
				  .map(it => ({
					  Content: `${it.name} ${it.status}`,
					  Tag: it,
					  IsCheckBox: true,
					  FontImage: ' '
				  }))])
	}

	checkEnabledOk()
	{
		this._okButton.setEnabled(this._ad2 && this._ad1);
	}

	getSelectedCards()
	{
		return this._cardList.getItems()
			 .filter(c => c instanceof ListItemCheckBox && c.getSelected())
			 .map(c => c.getTag() as UserCard)
	}

	getParams()
	{
		return [...this._listAd1.getItems(), ...this._listAd2.getItems()]
			 .filter(c => c instanceof ListItemCheckBox && c.getSelected())
			 .map(c => c.getTag() as DistributionPoint);
	}
}
